import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Spinner, Carousel, Modal } from 'react-bootstrap';
import Card from '../../../components/Card';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import productImage from '../../../assets/images/store/product.jpeg';
import { useTranslation } from 'react-i18next';
import { CircularProgress } from "@mui/material";
import { getToken } from '../../../utils/auth';

const ProductDetail = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loadingFull, setLoadingFull] = useState(false);
  const [loadingFullGet, setLoadingFullGet] = useState(false);

  const [selectedCurrency, setSelectedCurrency] = useState(
    state?.selectedCurrency || localStorage.getItem('selectedCurrency') || 'INR'
  );
  const [currencySymbol, setCurrencySymbol] = useState(
    state?.currencySymbol || localStorage.getItem('currencySymbol') || '₹'
  );
  const { id } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t, i18n } = useTranslation();
  const [quantity, setQuantity] = useState(1);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [imageShow, setImageShow] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [cartData, setCartData] = useState([])
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(()=>{
    window.scroll(0,0);
    
    // Cleanup function to revoke object URLs when component unmounts
    return () => {
      if (preview) {
        URL.revokeObjectURL(preview);
      }
    };
  },[]);

  const handleThumbnailClick = (index) => {
    setActiveIndex(index);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    
    // Validate that a file was actually selected
    if (!file) {
      return;
    }
    
    // Validate file type
    if (!file.type.startsWith('image/')) {
      toast.error("Please select a valid image file.");
      return;
    }
    
    // Validate file size (e.g., max 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      toast.error("Image size should be less than 5MB.");
      return;
    }
    
    // Revoke previous preview URL to avoid memory leaks
    if (preview) {
      URL.revokeObjectURL(preview);
    }
    
    setSelectedFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append('user_id', customerID);
    formData.append('product_id', id);
    formData.append('image', selectedFile);

    try {
      setLoadingFull(true)

      const response = await axios.post(
        `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/cart/upload-item-image`,
        formData,
        {
          headers: {
            'Authorization': 'Basic YWRtaW46aTVJTyA5aEZyIGFIU00gOUtVVCBuc2pYIFFOb3A=',
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      handleCart(customerID)
      toast.success(response?.data?.message || "Image uploaded successfully.");
      
      // Clean up and close modal
      if (preview) {
        URL.revokeObjectURL(preview);
      }
      setShowUploadModal(false);
      setSelectedFile(null);
      setPreview(null);
      
      // Reset file input
      const fileInput = document.getElementById('fileUploadInput');
      if (fileInput) {
        fileInput.value = '';
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Image upload failed.");
    } finally{
      setLoadingFull(false)
    }
  };

  const handleChangeImage = async (id) => {
    const formData = new FormData();
    formData.append('cart_item_id', id);

    try {
      setLoadingFullGet(true)
      const response = await axios.post(
        `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/cart/remove-item-image`,
        formData,
        {
          headers: {
            'Authorization': 'Basic YWRtaW46aTVJTyA5aEZyIGFIU00gOUtVVCBuc2pYIFFOb3A=',
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      handleCart(customerID);
      fetchProducts();
      handleModalClose();
      toast.success(response?.data?.message || "Image Deleted successfully.");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed deleting image.");
    } finally{
      setLoadingFullGet(false)
    }
  };

  const availableStock = 10; 
  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value, 10);

    if (value > availableStock) {
      toast.error(`Quantity cannot exceed available stock (${availableStock})`);
      setQuantity(availableStock);
    } else if (value < 1) {
      toast.error('Quantity cannot be less than 1');
      setQuantity(1);
    } else {
      setQuantity(value);
    }
  };

  const fetchProducts = async () => {
    const url = `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/products/${id}?wmc-currency=${selectedCurrency}`;
    const authHeader = 'Basic YWRtaW46aTVJTyA5aEZyIGFIU00gOUtVVCBuc2pYIFFOb3A=';

    try {
      setLoadingFullGet(true)
      const response = await axios.get(url, {
        headers: {
          Authorization: authHeader,
        },
      });
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
      setLoadingFullGet(false)
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [id, selectedCurrency]);

  const [customerID, setCustomerID] = useState();

  const fetchUserData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(`${process.env.REACT_APP_URL}/api/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setCustomerID(response.data.data.customerId);
      handleCart(response.data.data.customerId)
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };

  const handleCart = async (customerID) => {
    try {
      setLoadingFullGet(true)
      const response = await axios.get(
        `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/cart/${customerID}?product_id=${id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic YWRtaW46aTVJTyA5aEZyIGFIU00gOUtVVCBuc2pYIFFOb3A='
          }
        }
      );
      setImageShow(response.data.items[0])
      setCartData(response.data.items)
    } catch (error) {
      console.error("Failed Fetching Details", error);
    } finally{
      setLoadingFullGet(false)
    }
  };

  useEffect(()=>{
    fetchUserData();
  },[])

  const handleGoToCart = () => {
    navigate("/store-checkout");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      setLoadingFull(true)

      const response = await axios.post(
        `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/cart`,
        {
          user_id: parseInt(customerID),
          product_id: parseInt(id),
          quantity: 1,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic YWRtaW46aTVJTyA5aEZyIGFIU00gOUtVVCBuc2pYIFFOb3A='
          }
        }
      );
      handleCart(customerID)
      toast.success(response?.data?.message || "Product added successfully");
     
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to add product");
      console.error('Failed adding product:', error);
    } finally{
      setLoadingFull(false)
    }
  };

  const handleModalOpen = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);
  
  const handleUploadModalOpen = () => setShowUploadModal(true);
  const handleUploadModalClose = () => {
    setShowUploadModal(false);
    
    // Revoke the preview URL to free memory
    if (preview) {
      URL.revokeObjectURL(preview);
    }
    
    setSelectedFile(null);
    setPreview(null);
    
    // Reset file input
    const fileInput = document.getElementById('fileUploadInput');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  return (
    <div>
      <Toaster position="top-right" reverseOrder={false}/>
      {loadingFull && (
        <div style={styles.loaderOverlay}>
          <CircularProgress style={{ color: "white" }} />
        </div>
      )}
      {loadingFullGet && (
        <div style={styles.loaderOverlay}>
          <CircularProgress style={{ color: "white" }} />
        </div>
      )}

      <div style={{ background: '#fafafa', minHeight: '100vh', paddingTop: '20px', paddingBottom: '30px' }}>
        <Container>
          <Row>
            <Col lg="12">
              {loading ? (
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: '60vh'
                }}>
                  <Spinner animation="border" variant="dark" style={{ width: '40px', height: '40px' }} />
                </div>
              ) : (
                <Row className="g-3">
                  {/* Image Gallery Section */}
                  {products?.qrc_data?.qrc_type !== 'special' && (
                    <Col xs={12} lg={7}>
                      <div style={{ position: 'sticky', top: '20px' }}>
                        {products?.images?.length > 0 ? (
                          <>
                            <div style={{
                              background: '#fff',
                              borderRadius: '0',
                              overflow: 'hidden',
                              marginBottom: '10px',
                              aspectRatio: '1/1',
                              position: 'relative'
                            }}>
                              <img
                                src={products.images[activeIndex]?.src}
                                alt={`product-${activeIndex}`}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover'
                                }}
                              />
                            </div>

                            {products.images.length > 1 && (
                              <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))',
                                gap: '8px'
                              }}>
                                {products.images.map((image, index) => (
                                  <div
                                    key={index}
                                    onClick={() => handleThumbnailClick(index)}
                                    style={{
                                      aspectRatio: '1/1',
                                      background: '#fff',
                                      cursor: 'pointer',
                                      overflow: 'hidden',
                                      opacity: activeIndex === index ? 1 : 0.5,
                                      transition: 'opacity 0.3s',
                                      border: activeIndex === index ? '2px solid #000' : '2px solid transparent'
                                    }}
                                  >
                                    <img
                                      src={image.src}
                                      alt={`thumb-${index}`}
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                      }}
                                    />
                                  </div>
                                ))}
                              </div>
                            )}
                          </>
                        ) : (
                          <div style={{
                            background: '#fff',
                            aspectRatio: '1/1',
                            overflow: 'hidden'
                          }}>
                            <img
                              src={productImage}
                              alt="product"
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </Col>
                  )}

                  {/* Product Details Section */}
                  <Col xs={12} lg={products?.qrc_data?.qrc_type === 'special' ? 12 : 5}>
                    <div style={{ paddingLeft: products?.qrc_data?.qrc_type !== 'special' ? '0px' : '0'}}>
                      
                      {/* Special QRC */}
                      {products?.qrc_data?.qrc_type === 'special' && (
                        <div style={{
                          background: '#000',
                          color: '#fff',
                          padding: '20px',
                          marginBottom: '20px',
                          textAlign: 'center'
                        }}>
                          <div style={{ fontSize: '12px', letterSpacing: '2px', marginBottom: '5px', textTransform: 'uppercase' }}>
                            {t('special_qrc')}
                          </div>
                          <div style={{ fontSize: '18px', fontWeight: '300' }}>
                            {products?.qrc_data?.qrc_title}
                          </div>
                        </div>
                      )}

                      {/* Product Title */}
                      <h1 style={{
                        fontSize: '28px',
                        fontWeight: '300',
                        color: '#000',
                        marginBottom: '12px',
                        letterSpacing: '-0.5px',
                        lineHeight: '1.2'
                      }}>
                        {products?.name}
                      </h1>

                      {/* Short Description */}
                      {products?.short_description && (
                        <div
                          style={{
                            fontSize: '13px',
                            color: '#666',
                            marginBottom: '20px',
                            lineHeight: '1.6'
                          }}
                          dangerouslySetInnerHTML={{ __html: products.short_description }}
                        />
                      )}

                      {/* Price */}
                      <div style={{ marginBottom: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px', marginBottom: '6px' }}>
                          <span style={{
                            fontSize: '28px',
                            fontWeight: '400',
                            color: '#000'
                          }}>
                            {currencySymbol || "₹"}{parseFloat(products?.sale_price || '0').toFixed(2)}
                          </span>
                          {products?.regular_price && products?.sale_price && products.regular_price !== products.sale_price && (
                            <span style={{
                              fontSize: '18px',
                              color: '#999',
                              textDecoration: 'line-through'
                            }}>
                              {currencySymbol || "₹"}{parseFloat(products?.regular_price || '0').toFixed(2)}
                            </span>
                          )}
                        </div>
                        {products?.regular_price && products?.sale_price && (
                          <div style={{
                            fontSize: '13px',
                            color: '#d32f2f',
                            fontWeight: '500'
                          }}>
                            Save {Math.round(((products.regular_price - products.sale_price) / products.regular_price) * 100)}%
                          </div>
                        )}
                      </div>

                      {/* Description */}
                      {products?.description && (
                        <div
                          style={{
                            fontSize: '13px',
                            color: '#666',
                            marginBottom: '25px',
                            lineHeight: '1.6',
                            paddingBottom: '20px',
                            borderBottom: '1px solid #eee'
                          }}
                          dangerouslySetInnerHTML={{ __html: products.description }}
                        />
                      )}

                      {/* Buttons */}
                      <div style={{ marginBottom: '15px'}}>
                        {cartData.length === 0 ? (
                          <Button
                            onClick={handleSubmit}
                            style={{
                              width: '100%',
                              padding: '14px',
                              fontSize: '13px',
                              fontWeight: '500',
                              letterSpacing: '1px',
                              textTransform: 'uppercase',
                              background: '#000',
                              border: 'none',
                              borderRadius: '0',
                              color: '#fff',
                              transition: 'all 0.3s'
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = '#333';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = '#000';
                            }}
                          >
                            {t('add_to_cart')}
                          </Button>
                        ) : (
                          <Button
                            onClick={handleGoToCart}
                            style={{
                              width: '100%',
                              padding: '14px',
                              fontSize: '13px',
                              fontWeight: '500',
                              letterSpacing: '1px',
                              textTransform: 'uppercase',
                              // background: 'orange',
                              backgroundColor:"orange",
                              border: 'none',
                              borderRadius: '0',
                              color: '#fff',
                              transition: 'all 0.3s'
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = '#ff8c00';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = 'orange';
                            }}
                          >
                            {t('go_to_cart')}
                          </Button>
                        )}
                      </div>

                      {/* Upload Button */}
                      {products?.qrc_data?.qrc_type === 'customize' && imageShow?.uploaded_image_id === null && (
                        <div style={{ marginTop: '15px' }}>
                          <Button
                            onClick={handleUploadModalOpen}
                            style={{
                              width: '100%',
                              padding: '14px',
                              fontSize: '13px',
                              fontWeight: '500',
                              letterSpacing: '1px',
                              textTransform: 'uppercase',
                              background: '#fff',
                              border: '1px solid #000',
                              borderRadius: '0',
                              color: '#000',
                              transition: 'all 0.3s'
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = '#000';
                              e.target.style.color = '#fff';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = '#fff';
                              e.target.style.color = '#000';
                            }}
                          >
                            {t('upload_image')}
                          </Button>
                        </div>
                      )}

                      {/* View Uploaded */}
                      {imageShow?.uploaded_image && (
                        <div style={{
                          marginTop: '15px',
                          textAlign: 'center',
                          paddingTop: '15px',
                          borderTop: '1px solid #eee'
                        }}>
                          <Link
                            to="#"
                            onClick={handleModalOpen}
                            style={{
                              color: '#000',
                              fontSize: '12px',
                              textDecoration: 'underline',
                              textTransform: 'uppercase',
                              letterSpacing: '1px',
                              fontWeight: '500'
                            }}
                          >
                            {t('view_uploaded_image')}
                          </Link>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Container>
      </div>
      
      {/* Upload Modal */}
      <Modal show={showUploadModal} onHide={handleUploadModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t('upload_image')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ textAlign: 'center' }}>
            <input
              id="fileUploadInput"
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
            
            {!preview ? (
              <div 
                onClick={() => document.getElementById('fileUploadInput').click()}
                style={{
                  border: '2px dashed #ccc',
                  borderRadius: '8px',
                  padding: '40px 20px',
                  cursor: 'pointer',
                  transition: 'all 0.3s',
                  background: '#fafafa'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#000';
                  e.currentTarget.style.background = '#f5f5f5';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#ccc';
                  e.currentTarget.style.background = '#fafafa';
                }}
              >
                <div style={{ fontSize: '48px', marginBottom: '10px', color: '#999' }}>📷</div>
                <div style={{ fontSize: '14px', color: '#666', marginBottom: '5px' }}>
                  Click to select image
                </div>
                <div style={{ fontSize: '12px', color: '#999' }}>
                  or drag and drop
                </div>
              </div>
            ) : (
              <div>
                <div style={{
                  marginBottom: '15px',
                  background: '#fff',
                  padding: '8px',
                  borderRadius: '8px',
                  border: '1px solid #eee'
                }}>
                  <img
                    src={preview}
                    alt="Preview"
                    style={{
                      width: '100%',
                      height: 'auto',
                      maxHeight: '300px',
                      objectFit: 'contain',
                      borderRadius: '4px'
                    }}
                  />
                </div>
                <Button
                  onClick={() => document.getElementById('fileUploadInput').click()}
                  variant="outline-dark"
                  style={{
                    fontSize: '12px',
                    padding: '8px 16px',
                    borderRadius: '0',
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                  }}
                >
                  Change Image
                </Button>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <Button 
            variant="secondary" 
            onClick={handleUploadModalClose}
            style={{
              borderRadius: '0',
              padding: '10px 20px',
              textTransform: 'uppercase',
              fontSize: '12px',
              letterSpacing: '1px'
            }}
          >
            {t('close')}
          </Button>
          <Button 
            variant="dark"
            onClick={handleUpload}
            disabled={!selectedFile}
            style={{
              borderRadius: '0',
              padding: '10px 20px',
              textTransform: 'uppercase',
              fontSize: '12px',
              letterSpacing: '1px',
              opacity: !selectedFile ? 0.5 : 1
            }}
          >
            {t('submit_button')}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* View Uploaded Image Modal */}
      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t('uploaded_image')}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{display:"flex"}}>
          {imageShow?.uploaded_image ? (
            <img
              src={imageShow?.uploaded_image}
              alt="Uploaded"
              style={{ display:"flex", marginInline:"auto", maxWidth:"300px", width: '100%', height: 'auto', borderRadius: '8px' }}
            />
          ) : (
            <p>{t('no_image_uploaded')}</p>
          )}
        </Modal.Body>
        <Modal.Footer style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <Button 
            variant="primary" 
            onClick={()=>handleChangeImage(imageShow?.id)}
            style={{
              borderRadius: '0',
              padding: '10px 20px',
              textTransform: 'uppercase',
              fontSize: '12px',
              letterSpacing: '1px'
            }}
          >
            {t('delete')}
          </Button>
          <Button 
            variant="secondary" 
            onClick={handleModalClose}
            style={{
              borderRadius: '0',
              padding: '10px 20px',
              textTransform: 'uppercase',
              fontSize: '12px',
              letterSpacing: '1px'
            }}
          >
            {t('close')}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};

export default ProductDetail;